import React from 'react';
import { TouchableOpacity, Text } from 'react-native';
import { ScaledSheet } from '@utils/scale';

interface TransactionHistoryLinkProps {
  title: string;
  onPress: () => void;
}

/**
 * TransactionHistoryLink Component
 * Link to view transaction history
 */
const TransactionHistoryLink: React.FC<TransactionHistoryLinkProps> = ({
  title,
  onPress,
}) => {
  return (
    <TouchableOpacity
      style={styles.container}
      onPress={onPress}
      activeOpacity={0.7}
    >
      <Text style={styles.label}>{title}</Text>
      <Text style={styles.arrow}>›</Text>
    </TouchableOpacity>
  );
};

const styles = ScaledSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 20,
    paddingVertical: 18,
    marginHorizontal: 16,
    marginTop: 12,
    borderRadius: 12,
  },
  label: {
    fontSize: 16,
    fontWeight: '500',
    color: '#000000',
  },
  arrow: {
    fontSize: 20,
    color: '#BDBDBD',
    fontWeight: '300',
  },
});

export default TransactionHistoryLink;


